import { render } from "./BaseModal2.vue?vue&type=template&id=16af5d7c&scoped=true"
import script from "./BaseModal2.vue?vue&type=script&lang=js"
export * from "./BaseModal2.vue?vue&type=script&lang=js"

import "./BaseModal2.vue?vue&type=style&index=0&id=16af5d7c&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16af5d7c"]])

export default __exports__